import { isFunction, unset } from "lodash";
import { CRUDFabric } from "../CRUDs/CRUDFabric";
import { Preloader } from "../Common/Preloader";

class FilterEvent extends CustomEvent {};

export const Filter = (() => {

    let filterComplete;
    let filterReset;
    let dateInput;

    return class Filter {
        sectionTitle
        paginator = null

        constructor(entityClass) {
            this.sectionTitle = entityClass
            this.entityClass = CRUDFabric.getClass(entityClass);
            if (this.entityClass) {
                this.filterObject = new this.entityClass;
                this.filterContainer = $(`.filter[data-entity-class=${this.filterObject.entityClass}]`);
                this.filterContainer.find('.reset-filter-btn').on('click', ()=>{
                    this.resetAsDefault()
                    this.main()
                })
                this.filterContainer.find('.reset-filter-btn').attr('style', 'display:none !important;')
                this.fields = this.filterContainer.find('input, select');
                this.table = $(`.data-view.${this.filterObject.entityClass}s`);

                filterComplete = new FilterEvent('filter_complete', { detail: { source: `${this.filterObject.entityClass}s` } });
                filterReset = new FilterEvent('filter_reset', { detail: { source: `${this.filterObject.entityClass}s` } });
                this.showFilter();
                this.setDefaultValueFromUrl()
                this.listners();
                document.dispatchEvent(new CustomEvent('filter_initiated', { detail: { entity_class: entityClass } }));
            }
        }

        showFilter() {
            $(`.filter`).addClass('d-none');
            if (this.filterContainer) {
                this.filterContainer.removeClass('d-none');
                if (this.filterContainer.find('[name=date-range]').length) {
                    dateInput = this.filterContainer.find('input[name=date-range]');
                    let datepicker;
                    dateInput.off('click').on('click', function() {
                        if (!datepicker) {
                            datepicker = dateInput.daterangepicker({
                                format: 'MM/DD/YYYY',
                                separator: ' - ',
                            });
                            dateInput[0].click();
                        }
                    });

                    this.filterContainer.off('apply.daterangepicker', 'input[name=date-range]')
                                .on('apply.daterangepicker', 'input[name=date-range]', (ev, picker) => this.main())
                                .off('cancel.daterangepicker')
                                .on('cancel.daterangepicker', (ev, picker) => {
                                    dateInput.val('');
                                    removeQueryParamWithName('date-range[start]')
                                    removeQueryParamWithName('date-range[end]')
                                    removeQueryParamWithName('date-field')
                                    removeQueryParamWithName('date-range')
                                    this.main();
                                });
                }
                this.showHideSpecialLabel(this.filterContainer.find('select#status'));
            }
        }

        setDefaultValueFromUrl(){
            const url = new URL(window.location.href)
            const searchEntity = url.searchParams.get('entity_class')
            if (searchEntity && searchEntity.replace(/s$/, '') == this.filterObject.entityClass) {
                if(this.fields?.length){
                    for (let field of this.fields) {
                        const urlValue = url.searchParams.get(field.name)
                        if(urlValue){
                            if(field.tagName.toLowerCase() == 'select'){
                                $(field).find(`option[value=${urlValue}]`).prop('selected',true)
                                this.showHideSpecialLabel(field);
                            }else{
                                field.value = urlValue
                            }
                        }
                    }
                    let start = url.searchParams.get('date-range[start]')
                    let end = url.searchParams.get('date-range[end]')
                    const dateRange = this.filterContainer.find('input[name=date-range]')
                    if (start && end && dateRange) {
                        const date = new Date();
                        let start = new Date(Date.parse(url.searchParams.get('date-range[start]')) - (date.getTimezoneOffset() * 60000))
                        let end = new Date(Date.parse(url.searchParams.get('date-range[end]')) - (date.getTimezoneOffset() * 60000))
                        start = Intl.DateTimeFormat('en').format(start).split('/').map(dg => dg.padStart(2, '0')).join('/')
                        end = Intl.DateTimeFormat('en').format(end).split('/').map(dg => dg.padStart(2, '0')).join('/')
                        dateRange.val(`${start} - ${end}`)
                    }
                }
            }else if(!searchEntity){
                setQueryParams({'entity_class': this.filterObject.entityClass+'s'})
            }
        }

        main(additionalFilterData={}, directionView=null, setParams=true, checkImportants=false) {
            return new Promise((resolve) => {
                if (this.fields) {
                    const filterData = this.collectData(additionalFilterData, setParams, checkImportants);
                    const isDefault = filterData.isDefault
                    delete filterData.isDefault
                    const checker = [... new Set(Object.values(filterData))];
                    const isCheck = checker.reduce((acc,cur)=>acc|=(/[0-9]+/.test(cur) ? Boolean(Number(cur)) : Boolean(cur)),false)
                    if(!isCheck) {
                        this.reset();
                    }
                    let currentUrl = new URL(window.location.href)

                    const preloader = new Preloader('data-tables');
                    preloader.open();
                    const entityClassParam = { entity_class: this.filterObject.entityClass };
                    this.filterObject
                        .filter(Object.assign(entityClassParam, filterData))
                        .then((result) => {
                            if(result.view){
                                this.showResult(result.view, directionView, preloader);
                                if (jQuery.isFunction(this.filterObject.getWorkersForFilter)) {
                                    this.filterObject.getWorkersForFilter(filterData);
                                }
                            }
                            preloader.close();

                            document.dispatchEvent(new CustomEvent('filter_completed', { detail: { source: this, allCount:result.allCount }}));
                            resolve(result.allCount)
                            console.log(isDefault)
                            if (!isDefault)
                                this.filterContainer.find('.reset-filter-btn').attr('style', '')
                            else
                                this.filterContainer.find('.reset-filter-btn').attr('style', 'display:none !important')
                        });
                }
            });
        }

        collectData(additionalFilterData={}, setParams=true, checkImportants=false) {
            let data = {};
            const importants = [];
            let isDefault = true;
            for (let field of this.fields) {
                if (field.name !== "") {
                    data[field.name] = field.value;
                    if(field.hasAttribute('data-default-value'))
                        isDefault &= field.value == field.getAttribute('data-default-value')
                    else
                        isDefault &= field.value=='' || field.value == 0
                    if (field.hasAttribute('data-important')) importants.push(field.name);
                    if (setParams && field.name != 'date-range') setQueryParams({[field.name]: field.value});
                }
            }
            if (data['date-range']) {
                const [start, end] = data['date-range'].split('-');
                date = new Date();
                data['date-range'] = {
                    start: new Date(Date.parse(start) - (date.getTimezoneOffset() * 60000)).toISOString().slice(0, 10), //надо учитывать timezone в js
                    end: new Date(Date.parse(end) - (date.getTimezoneOffset() * 60000)).toISOString().slice(0, 10),
                }
                data['date-field'] = this.filterContainer.find('[name="date-range"]').data('filter-field') ?? 'created_at';

                if (setParams)
                    setQueryParams({
                        "date-range[start]": data['date-range']['start'],
                        "date-range[end]": data['date-range']['end'],
                        'date-field': data['date-field']
                    });
            }

            isDefault &= Object.keys(additionalFilterData).length==0

            let filterData = {...data, ...additionalFilterData};
            filterData = {...filterData, isDefault}
            if (importants.length && checkImportants) {
                const importantsResult = Object.keys(filterData)
                    .filter((key) => importants.includes(key))
                    .reduce((result, key) => { return Object.assign(result, { [key]: filterData[key] }) }, {});

                filterData = importantsResult;
            }

            if(this.paginator !== null && !isNaN(this.paginator.getPaginatedPageNumber())){
                filterData.page = this.paginator.getPaginatedPageNumber()
                filterData.limit = this.paginator.VISIBLE_COUNT
            }

            return filterData;
        }

        reset() {
            for (let field of this.fields) {
                const tagName = field.tagName.toLowerCase();
                if (tagName == 'input') field.value = '';
                else if (tagName == 'select') {
                    field.value = 0;
                }
            }
            this.fields.parents('.filter').find('.custom-select-new .label').css({'display': 'none'});
            this.table.find(`.data-row`).css('display', 'table-row');
            this.table.find(`.show-more-rows`).css('display', 'block');
            removeQueryParams();
            document.dispatchEvent(filterReset);
            this.filterContainer.find('.reset-filter-btn').attr('style','display:none !important;');
            return this;
        }

        resetAsDefault(){
            for (let field of this.fields) {
                const tagName = field.tagName.toLowerCase();
                if (tagName == 'input') field.value = $(field).data('default-value') ?? '';
                else if (tagName == 'select') {
                    const defaultValue = $(field).data('default-value')
                    if(defaultValue){
                        $(field).find(`option[value="${defaultValue}"]`).prop('selected', true);
                    }else{
                        field.value=0
                    }
                }
            }
            this.table.find(`.data-row`).css('display', 'table-row');
            this.table.find(`.show-more-rows`).css('display', 'block');
            removeQueryParams();
            document.dispatchEvent(filterReset);
            this.filterContainer.find('.reset-filter-btn').attr('style','display:none !important;');
            return this;
        }

        showResult(resultHTML, directionView=null, preloader = null) {
            const container = directionView ? $(`.data-view.${directionView}s`) : this.table;

            const element = document.createElement('div');
            element.innerHTML = resultHTML;
            container.html(element.firstChild.innerHTML);
            document.dispatchEvent(filterComplete);
            /* if (preloader) {
                preloader.close();
            } */
            return this;
        }

        refreshURL() {
            const filterData = this.collectData();
            setQueryParams(filterData);
        }

        listners() {
            this.filterContainer.find('.filter-field input').off('keypress').on('keypress',(e)=>{
                if (e.key == 'Enter') {
                    if($(e.currentTarget).val() == '' || $(e.currentTarget).val() == null){
                        removeQueryParamWithName($(e.currentTarget).attr('name'))
                    }
                    this.main()
                }
            })

            $(document).on('trigger_filter', () => { this.main()});
            this.filterContainer.find('select').off('change').on('change', (e, payload) => {
                if (payload){
                    this.main(payload.filterData, payload?.directionView, false);
                }else
                    this.main();
                this.showHideSpecialLabel(e.target);
            });
        }

        static start(className) {
            const params = new URL(window.location.href).searchParams;
            const section = className ?? params.get('entity_class');
            return new Filter(section);
        }

        showHideSpecialLabel(target){
            if($(target).find(`option:selected`).data('label')) {
                $(target).closest('div').find('.label.special-label').text($(target).find(`option:selected`).data('label')).addClass('d-block').removeClass('d-none');
            }else{
                $(target).closest('div').find('.label.special-label').removeClass('d-block').addClass('d-none');
            }
        }
    }
})();

export const setQueryParams = (params={}) => {
    const currentURL = window.location.href;
    const newURL = new URL(currentURL);

    for (const [param, value] of Object.entries(params)) {
        if (value) newURL.searchParams.set(param, value);
    }
    window.history.replaceState({}, '', newURL.toString());
}

const removeQueryParamWithName = (name) =>{
    const currentURL = window.location.href;
    const newURL = new URL(currentURL);
    newURL.searchParams.delete(name);
    window.history.replaceState({}, '', newURL.toString());
}

export const removeQueryParams = () => {
    const currentURL = new URL(window.location.href);
    const entityCls = currentURL.searchParams.get('entity_class')
    currentURL.search = `?entity_class=${entityCls}`
    window.history.replaceState({}, '', currentURL);
}
